<template>
  <div class="compare-map" v-bind:style="compareMapStyle" v-show="compareFeature">
    <div class="row no-gutters align-items-center" style="background-color:#eee;">
      <div class="col-4">
        <div class="map-title" v-bind:title="map1Title">{{map1Title}}</div>
      </div>
      <div class="col-4" style="border-left:1px solid #ccc;border-right:1px solid #ccc;">
        <div class="map-title" v-bind:title="map2Title">{{map2Title}}</div>
      </div>
      <div class="col-4" style="">
        <div class="map-title">More insights about this location</div>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-8">

        <div class="row no-gutters" style="background-color:#eee;">
          <div class="col" style="border-left:0px solid #ccc;border-right:1px solid #ccc;border-bottom:1px solid #ccc;">

          </div>
        </div>

        <div class="row no-gutters" style="height:400px;">
          <div class="col">
                        <div ref="map1" style="border-right:1px solid #666;height:400px;background-color:#666;position:relative;top:0;z-index:100;"></div>

            <form class="layer-select-overlay" style="position:relative;top:-400px;padding:3px 7px;;">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="showOption" v-bind:id="this.uuid+'-showOptionSatellite'" value="satellite" v-model="showOption">
                  <label class="form-check-label" v-bind:for="this.uuid+'-showOptionSatellite'">
                    Show satellite layer selected from the list below
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="showOption" v-bind:id="this.uuid+'-showOptionOSM'" value="osm" v-model="showOption">
                  <label class="form-check-label" v-bind:for="this.uuid+'-showOptionOSM'">
                    Show reference map from OpenStreetMap
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="showOption" v-bind:id="this.uuid+'-showOptionAerial'" value="aerial" v-model="showOption">
                  <label class="form-check-label" v-bind:for="this.uuid+'-showOptionAerial'">
                    Show reference hi-res image from unknown date
                  </label>
                </div>


            </form>

          </div>
          <div class="col" style="">
            
            <div ref="map2" style="height:400px;background-color:#666;"></div>
            
          </div>
        </div>


        <div class="row no-gutters" v-if="compareFeature">
          <div class="col-6" style="border-right:1px solid #ccc;padding:0px;">


          
            <div class="row no-gutters align-items-center" style="background-color:#eee;border-top:0px solid #ccc;padding:6px;">
              <!--<div class="col-2">
                <a href="#" style="color:#999;font-size:0.85em;"><i class="bi bi-arrow-left-circle"></i></i></a>
              </div>-->
              <div class="col text-left">
                  <h5 style="padding-bottom:5px;clear:left;">Images before {{compareFeature.repr_date}}</h5>
              </div>
              <!--
              <div class="col-2 text-right">
                  <a href="#" style="color:#999;font-size:0.85em;"><i class="bi bi-arrow-right-circle"></i></i></a>
              </div>-->
            </div>

            
            
            <div style="line-height:18px;width:100%;padding:5px;">
              <a class="layer-selector-link" v-bind:style="styleForLayer(layer)" v-bind:title="titleForLayer(layer)" href="#" v-for="layer in map1Layers" @click.prevent="selectMap1Layer(layer)"></a>
            </div>


          </div>
          <div class="col-6 text-left" style="border-right:1px solid #ccc;;">

            <div class="row no-gutters align-items-center" style="background-color:#eee;border-top:0px solid #ccc;padding:6px;">
              <!--<div class="col-2">
                <a href="#" style="color:#999;font-size:0.85em;"><i class="bi bi-arrow-left-circle"></i></i></a>
              </div>-->
              <div class="col text-left">
                  <h5 style="padding-bottom:5px;clear:left;">Images after {{compareFeature.repr_date}}</h5>
              </div>
              <!--
              <div class="col-2 text-right">
                  <a href="#" style="color:#999;font-size:0.85em;"><i class="bi bi-arrow-right-circle"></i></i></a>
              </div>-->
            </div>

            <div style="line-height:18px;width:100%;padding:5px;">
              <a class="layer-selector-link" v-bind:style="styleForLayer(layer)" v-bind:title="titleForLayer(layer)" href="#" v-for="layer in map2Layers" @click.prevent="selectMap2Layer(layer)"></a>
            </div>


          </div>

        </div>
        <div class="row">
          <div class="col">
            <div style="border-top:1px solid #ccc;padding:0px 5px;">
              <div style="font-size:0.6em;">
                <div style="margin-bottom:-1px;display:inline-block;height:11px;width:11px;border:1px solid #333;background-color:#e5f5e0;border-radius:20px;"></div> Low resolution Landsat 7 image&nbsp;&nbsp;&nbsp;
                <div style="margin-bottom:-1px;display:inline-block;height:11px;width:11px;border:1px solid #333;background-color:#a1d99b;border-radius:20px;"></div> Medium resolution Sentinel 2 image&nbsp;&nbsp;&nbsp;
                <div style="margin-bottom:-1px;display:inline-block;height:11px;width:11px;border:1px solid #333;background-color:#31a354;border-radius:20px;"></div> High resolution Planet image
              </div>
            </div>
          </div>
        </div>


      </div>


      <div class="col-4">
        <div class="insights" v-if="compareFeature">
        <p>
          This change in the landscape was detected during <strong>{{ compareFeature.slot  }}</strong> in the 

                      <span v-if="compareFeature.source == 'glad_forest_loss_alerts'"><strong>Forest Loss Alerts</strong> dataset by GLAD, which detects tree cover loss events.</span>
                      <span v-else-if="compareFeature.source== 'wur_radd_alerts'"><strong>RADD Forest Disturbance Alerts</strong>, which detects forest Disturbances using radar data.</span>
                      <span v-else-if="compareFeature.source == 'images_forest_alerts'"><strong>IMAGES Forest Disturbances data</strong>, which detects forest disturbances. </span>
                      <span v-else-if="compareFeature.source == 'hansen_forest_loss_hotspots'"><strong>Tree Cover Loss</strong> data by Global Forest Watch.</span>
                      <span v-else-if="compareFeature.source== 'jrc_tmf_deforestation_hotspots'"><strong>Tropical Forest Deforestation</strong> by the JRC/European Commision.</span>
                      <span v-else-if="compareFeature.source == 'jrc_tmf_degradation_hotspots'"><strong>Tropical Forest Degradation</strong> by the JRC/European Commision.</span>
                      <span v-else-if="compareFeature.source == 'images_disturbance_hotspots'"><strong>IMAGES Forest Disturbances data</strong>, which detects forest disturbances.</span>
                      <span v-else-if="compareFeature.source == 'ciat_terra_i'"><strong>Terra-i Forest Disturbances</strong> data by CIAT.</span>
                      <span v-else-if="compareFeature.source == 'jrc_surface_water_changes'"><strong>Surface Water Dynamics</strong> data by JRC.</span>
                      <span v-else>{{compareFeature.name}}</span>


           It has a size of <strong>{{ compareFeature.area | ha}}ha</strong> and is centered at longitude  <strong>{{ compareFeature.x | coord }}</strong> and latitude <strong>{{ compareFeature.y | coord }}</strong>.
        </p>

        <table>
          <tr>
            <th colspan="3">+ <a @click.prevent="showLocationDetail='administrative'" href="#">Administrative divisions</a><a class="explainer-link" style="float:right;" href="#" @click.prevent="explainerStart('ldr_insights_administrative')"><i class="bi bi-question-circle"></i></a></th>
          </tr>
          <tbody v-show="showLocationDetail=='administrative'">
          <tr v-if="locationInfoStatus"><td colspan="10">{{locationInfoStatus}}</td></tr>
          <template v-if="locationInfo">
            <tr class="subheader"><td>Level</td><td>Type</td><td>Name</td></tr>
            <tr v-for="adm in locationInfo.admin">
              <td>{{adm.level}}</td>
              <td>{{adm.type}}</td>
              <td>{{adm.name}}</td>
            </tr>
          </template>
          </tbody>
        </table>

        <table>
          <tr>
            <th colspan="3">+ <a @click.prevent="showLocationDetail='protected'" href="#">Protected areas</a>

            <a class="explainer-link" style="float:right;" href="#" @click.prevent="explainerStart('ldr_insights_protectedareas')"><i class="bi bi-question-circle"></i></a>
            </th>
          </tr>
          <tbody v-show="showLocationDetail=='protected'">
          <tr v-if="locationInfoStatus"><td colspan="10">{{locationInfoStatus}}</td></tr>
          <template  v-if="locationInfo">
            <tr class="subheader"><td>Type</td><td>Name</td><td>IUCN Cat.</td></tr>
            <tr v-for="area in locationInfo.protected_areas">
              <td>{{area.name}}</td>
              <td>{{area.desig_eng}}</td>
              <td>{{area.iucn_cat}}</td>
            </tr>
            <tr v-if="locationInfo.protected_areas.length == 0"><td colspan="3">No protected areas were found in the World Database of Protected Areas that overlap with this location.</td></tr>
          </template>
          </tbody>
        </table>

        <table>
          <tr>
            <th colspan="1">+ <a @click.prevent="showLocationDetail='forests'" href="#">Forest insights</a> 
            <a class="explainer-link" style="float:right;" href="#" @click.prevent="explainerStart('ldr_insights_forests')"><i class="bi bi-question-circle"></i></a></th>
          </tr>
          <tbody v-show="showLocationDetail=='forests'">
          <tr v-if="locationInfoStatus"><td colspan="10">{{locationInfoStatus}}</td></tr>
          <template  v-if="locationInfo">
            <tr><td>
              <p v-if="locationInfo.forest_info.primary">
                This location was <strong>classified as primary forest</strong> during a global assessment in 2000. 
                <template v-if="locationInfo.forest_info.lossyear > 0">However, this may no longer be the case as a <strong>tree cover loss event was detected in {{ locationInfo.forest_info.lossyear }}</strong>.</template>
                <template v-else>However, it is unknown if this is still the case.</template>
              </p>
              <p v-else>
                This location was <strong>not classified as primary forest</strong> during a global assessment in 2000.
                <template v-if="locationInfo.forest_info.lossyear > 0">A  <strong>tree cover loss event was detected in {{ locationInfo.forest_info.lossyear }}</strong> in data by Global Forest Watch.</template>
                <!-- template v-else>However, <strong>no tree cover loss</strong> events were detected here since then.</template -->
              </p>

              <p v-if="locationInfo.forest_info.integrity">
                The <strong>forest landscape integrity index is {{ locationInfo.forest_info.integrity | fixed1 }}</strong>. 
                <template v-if="locationInfo.forest_info.integrity > 9.6">
                  This is a <strong>high forest integrity</strong> typical for more or less <strong>unmodified and naturally regenerated</strong> forests comprised almost entirely of native species.
                </template>
                <template v-else-if="locationInfo.forest_info.integrity > 6.0">
                  This is a <strong>medium forest integrity</strong> typical of naturally regenerated forest ecosystems in blocks smaller than their natural extent, but large enough to have some areas free of anthropogenic effects.
                </template>
                <template v-else-if="locationInfo.forest_info.integrity > 0">
                  This is a <strong>low forest integrity</strong>, which is representative of a diverse range of <strong>heavily modified and often internally fragmented ecosystems</strong> dominated by trees.
                </template>
                The index is calculated at the beginning of 2019.
              </p>
              <p v-else>
                No value for the <strong>forest integrity index</strong> was found for this location. This can happen for areas which are no longer forested.
              </p>
              <p v-if="locationInfo.forest_info.worldcover">
                In the WorldCover dataset from 2021 this location is classified as <strong>{{ locationInfo.forest_info.worldcover }}</strong>.
              </p>
            </td></tr>
          </template>
          </tbody>
        </table>
        <table style="border-bottom:1px solid #ccc;">
          <tr>
            <th colspan="1">+ <a @click.prevent="showLocationDetail='custom'" href="#">Custom data analysis</a>
            <a class="explainer-link" style="float:right;" href="#" @click.prevent="explainerStart('ldr_insights_custom_analysis')"><i class="bi bi-question-circle"></i></a></th>
          </tr>
          <tbody v-show="showLocationDetail=='custom'">
          <tr>
            <td>
              <p>
              It is possible to add or develop custom analysis or insights to this section. </p>
              <p>For example, finding a nearby processing
              facility, nearest city, or retrieving data from a custom land cover map. Please contact us with some more information about the type of insights you are interested in..</p>
            </td>
          </tr>
          </tbody>
        </table>


        </div>

      </div>


    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Leaflet from 'leaflet';
import "leaflet/dist/leaflet.css";

import omnivore from "@mapbox/leaflet-omnivore";

let uuid = 0;

export default {
    name: 'CompareMap',
    components: { },
    props: ['location', 'factsheet', 'loaded', 'compareFeature', 'componentHeight'],
    data() {
      return {
        height: 400,
        layers: [],
        map0: null,
        map1: null,
        map2: null,
        map1Title: null,
        map2Title: null,
        map1SelectedLayer: null,
        map2SelectedLayer: null,
        map1DataLayer: null,
        map2DataLayer: null,
        map1PreferredSelectedLayer: '',
        map2PreferredSelectedLayer: '',
        map0Detail: null,
        map1Detail: null,
        map2Detail: null,
        showOverlay: false,
        showOption: 'satellite',
        showLocationDetail: 'administrative',
        locationInfo: null,
        locationInfoStatus: 'Loading, please wait...'
      }
    },
    beforeCreate() {
      this.uuid = "comparemap-"+uuid.toString();
      uuid += 1;
    },
    created() {
      var url = process.env.VUE_APP_API+'/api/layers?f='+this.factsheet.identifier;
        this.$axios.get(url)
          .then(response => {
              var layers = []
              for (var i=0; i<response.data["results"].length; i++) {
                var layer = response.data["results"][i]
                layer["dateObj"] = Date.parse(layer["date"])
                layers.push(layer)
              }
              this.layers = layers
          })
    },
    updated() {

    },
    mounted() {
      //this.initMaps();
    },
    watch: {
      showOverlay() {
        if(this.showOverlay) {
          this.map1DataLayer.setOpacity(0);
          //this.map2DataLayer.setOpacity(0.6);
        } else {
          this.map1DataLayer.setOpacity(0);
          //this.map2DataLayer.setOpacity(0);
        }
      },
      showOption() {
        console.log("Updated showOption!")
        var url = ""
        if(this.showOption == 'aerial') {
          url = "https://api.mapbox.com/styles/v1/kokoalberti/cko0dmr3e0s3r17nbhxvkcr9x/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoia29rb2FsYmVydGkiLCJhIjoiY2o4b29rcmhkMDV1ajJ3cXVscmRmOXUxdCJ9.FVz71teDJoWI_bjJP2Pe8g"
          this.map1Title = "Reference high-resolution image (date unknown)"
        }
        else if(this.showOption == 'osm') {
          url = "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          this.map1Title = "Reference map from OpenStreetMap"
        }
        else if(this.showOption == 'satellite') {
          url = this.urlForLayer(this.map1SelectedLayer);
          this.map1Title = this.map1SelectedLayer["title"]
        }
        this.map1Layer.setUrl(url);
      },
      map1SelectedLayer() {
        if(this.map1SelectedLayer && this.map1Layer) {
          var url = this.urlForLayer(this.map1SelectedLayer); 
          this.map1Title = this.map1SelectedLayer["title"]
          this.map1Layer.setUrl(url);  
        }
      },
      map2SelectedLayer() {
        if(this.map2SelectedLayer && this.map2Layer) {
          var url = this.urlForLayer(this.map2SelectedLayer);
          this.map2Title = this.map2SelectedLayer["title"]
          this.map2Layer.setUrl(url);
        }
      },
      compareFeature() {
        console.log("Compare feature updated!")
        console.log(this.compareFeature)

        if(!this.map1 || !this.map2) {
          console.log("Initializing maps first time around...")
          this.initMaps();
        }

        if(!this.compareFeature) {
          return;
        } else {
          /* Pan the map to the right place right away, load the shape afterwards. */
          this.map1.panTo({lng: this.compareFeature['x'], lat: this.compareFeature['y'] })
        }

        console.log("Updating location info...")
        this.updateLocationInfo()



        if (this.compareFeature.hasOwnProperty('wkt_range')) {
          //var alertsListUrl = process.env.VUE_APP_API+'/data/factsheet'+this.factsheet.dataset_paths[this.compareFeature['source']]+'/alerts_list_geom.txt'
          // Be sure to remove withCredentials from get request when fetching directly from app

          var alertsListUrl = process.env.VUE_APP_DATABUCKET+'/factsheet'+this.factsheet.dataset_paths[this.compareFeature['source']]+'/alerts_list_geom.txt'


          // This url should be used, but caching of range requests is not working.
          //var dataset_id = this.factsheet.dataset_ids[this.compareFeature['source']]
          //var alertsListUrl = process.env.VUE_APP_API+'/data/factsheet/'+this.factsheet.info.identifier+'/data/'+dataset_id+'/alerts_list_geom.txt';
          
          this.$axios
              .get(alertsListUrl, { withCredentials: false, headers: { 'Range': 'bytes='+this.compareFeature['wkt_range'] }})
              .then(response => {
                  if(response.status == 206) { // Partial content ok
                      this.loadAlertWKT(response.data)
                  }
              }).catch(err => {
                  console.log("Range request to load an alert failed.")
                  console.log(err)
              });
        } else {
          console.log("Loading wkt directlyu:")
          console.log(this.compareFeature['wkt_geom'])
          this.loadAlertWKT(this.compareFeature['wkt_geom'])
        }

        this.clearDetails()

        if(this.compareFeature) {
          var url = process.env.VUE_APP_API+'/tools/raster/'+this.factsheet['identifier']+'/'+this.layer['dataset_id']+'/'+this.compareFeature["slot"]+'.tif~/tile/{z}/{x}/{y}.png';
          this.map1DataLayer.setUrl(url);
        }
  
      }
    },
    methods: {
      loadAlertWKT(wkt) {
        this.$nextTick(() => {
          const customLayer = L.geoJson(null, {
              interactive: false,
              style: function(feature) {
                  return {
                      "color": "#e50000",
                      "weight": 2,
                      "opacity": 1,
                      "fillOpacity": 0
                  };
              }
          });
          var map1Detail = _.cloneDeep(omnivore.wkt.parse(wkt, null, customLayer));
          map1Detail["_isDetail"] = true;
          var map2Detail = _.cloneDeep(map1Detail);
          map1Detail.addTo(this.map1);
          map2Detail.addTo(this.map2);
          this.map1.invalidateSize();
          this.map2.invalidateSize();
          this.map2.fitBounds(map2Detail.getBounds());
        });
      },
      updateLocationInfo() {
        this.locationInfo = null;
        if(this.compareFeature) {
          this.$axios
             .get(process.env.VUE_APP_API+"/tools/extra/hotspot", { params: { 'lat': this.compareFeature.y, 'lng': this.compareFeature.x } }, { timeout: 6 })
             .then(response => {
                if(response.data.results != null) {
                  this.locationInfo = response.data.results;
                  this.locationInfoStatus = ''
                } else {
                  this.locationInfoStatus = 'An error occurred while loading supplementary data.'
                }
             })
             .catch(error => {
              this.locationInfoStatus = 'An error occurred while loading supplementary data.'
             })          
        }

      },
      urlForLayer(layer) {
        if (layer["query_params"] != null) {
          var query_string = new URLSearchParams(layer["query_params"]).toString()
          return layer["url"]+'?'+query_string;
        } else {
          return layer["url"];
        }
      },
      styleForLayer(layer) {
        var color = "#ddd"
        var width = 1
        if(layer.resolution <= 5) {
          color = "#31a354"
        }
        else if(layer.resolution <= 10) {
          color = "#a1d99b"
        } else {
          color = "#e5f5e0"
        }
        if( (this.map1SelectedLayer) && (layer["id"] == this.map1SelectedLayer["id"]) ) {
          color = 'yellow'
          width = 2
        }
        if( (this.map2SelectedLayer) && (layer["id"] == this.map2SelectedLayer["id"]) ) {
          color = 'yellow'
          width = 2
        }
        return "font-size:0.5em;background-color:"+color+";border-radius:20px;display:inline-block;;width:15px;height:15px;margin:1px;border-width:"+width+"px;"
      },
      titleForLayer(layer) {
        return layer["title"]
      },
      selectMap1Layer(layer) {
        this.showOption = 'satellite'
        this.map1SelectedLayer = layer
      },
      selectMap2Layer(layer) {
        this.map2SelectedLayer = layer
      },
      clearDetails() {
        this.map1.eachLayer((layer) => {
          if(layer.hasOwnProperty("_isDetail")) {
            this.map1.removeLayer(layer);
          }
        });
        this.map2.eachLayer((layer) => {
          if(layer.hasOwnProperty("_isDetail")) {
            this.map2.removeLayer(layer);
          }
        });
        this.map1.invalidateSize();
        this.map2.invalidateSize();
      },
      initMap0() {
    
      },
      initMap1() {
        if(!this.map1) {
          this.map1 = L.map(this.$refs.map1, { 
            'attributionControl': false, 
            'scrollWheelZoom': false,
            'zoomControl': false }
          ).setView([51.505, -0.09], 4);
          L.control.scale().addTo(this.map1);
          this.map1.createPane('backgrounds');
          this.map1.getPane('backgrounds').style.zIndex = 100;
          this.map1.createPane('data');
          this.map1.getPane('data').style.zIndex = 200;
          this.map1Layer = L.tileLayer("", {'pane':'backgrounds'}).addTo(this.map1);
          this.map1DataLayer = L.tileLayer("", {'pane':'data', 'opacity': 0.0}).addTo(this.map1);
        }
      },
      initMap2() {
        if(!this.map2) {
          this.map2 = L.map(this.$refs.map2, { 
            'attributionControl': false, 
            'scrollWheelZoom': false,
            'zoomControl': false,
            'zoomAnimation': false,
            'maxZoom': 16 }
          ).setView([51.505, -0.09], 4);
          L.control.zoom({ position: 'topright' }).addTo(this.map2);
          this.map2.createPane('backgrounds');
          this.map2.getPane('backgrounds').style.zIndex = 100;
          this.map2.createPane('data');
          this.map2.getPane('data').style.zIndex = 200;

          this.map2Layer = L.tileLayer("", {'pane':'backgrounds'}).addTo(this.map2);
          //this.map2DataLayer = L.tileLayer("", {'pane':'data', 'opacity': 0.6}).addTo(this.map2);

          this.map2.on('move', (e) => {
             this.map1.fitBounds(this.map2.getBounds(), {'zoom': {'animate': false}, 'pan': {'animate': false}});
          });
          this.map2.on('zoom', (e) => {
             this.map1.fitBounds(this.map2.getBounds(), {'zoom': {'animate': false}, 'pan': {'animate': false}});
          });
        }
      },
      initMaps() {
        console.log("Initializing maps!")
        this.initMap1();
        this.initMap2();
        console.log("Done!")
      },

    },
    filters: {
      describeSlot: function(value) {
        if(value.length == 4) {
          return value
        } else {
          var parts = value.split("-")
          var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
          return months[parseInt(parts[1])]+" "+parts[0]
        }
        
      },
      ha: function(value) {
        if(value) {
          if(value > 100000) {
            return parseFloat(value/10000).toFixed(0);
          } else {
            return parseFloat(value/10000).toFixed(1);
          }
          
        }
        return ''
      },
      coord: function(value) {
        if(value) {
          return parseFloat(value).toFixed(4);
        }
        return ''
      },
      fixed1: function(value) {
        return value.toFixed(1)
      },
      integrity: function(value) {
        if(value > 9.6) {
          return "high"
        }
        if(value > 6) {
          return "medium"
        }
        if(value > 0) {
          return "low"
        }
      }
    },
    computed: {
      compareMapStyle() {
        console.log("Computing style height based on componentHeight: "+this.componentHeight)
        return "background-color:#f5f5f5;height:"+(this.componentHeight)+"px;position:relative;margin-top:-"+(this.componentHeight+1)+"px;z-index:999"
      },
      compareLayerStyle() {
        var height = this.componentHeight-470;
        return "min-height:"+height+"px;max-height:"+height+"px;overflow-x:hidden;overflow-y:scroll;"
      },
      map1Layers() {
        var layers = [];
        for (var i=0; i<this.layers.length; i++) {
          if(this.layers[i]["dateObj"] <= Date.parse(this.compareFeature["repr_date"])) {
            layers.push(this.layers[i])
          }
        }
        layers = _.reverse(layers);
        if (layers.length > 0) {
          this.map1SelectedLayer = layers[0]
        }
        return layers;
      },
      map2Layers() {
        var layers = [];
        for (var i=0; i<this.layers.length; i++) {
          if(this.layers[i]["dateObj"] > Date.parse(this.compareFeature["repr_date"])) {
            layers.push(this.layers[i])
          }
        }
        if (layers.length > 0) {
          this.map2SelectedLayer = layers[0]
        }
        return layers;
      }
    }
}
</script>
<style>
div.hotspot-location-icon {
  height:22px;
  witdh:22px;
  color:red;
  border-color:#e00000;
  background-color:#e00000;
  border-radius:200px;
}

</style>

<style scoped>
div.insights {
  padding:10px;
  font-size:0.7em;
}
div.insights table {
  width:100%;
  font-size:0.85em;
  border-right:1px solid #ccc;
  border-left:1px solid #ccc;
}
div.insights table p {
  padding:3px 0px;
  margin:0px;
}
div.insights table th {
  padding:2px 3px;
  border-top:1px solid #ddd;
  background-color:#fff;
}
div.insights table td {
  padding:3px;;
  padding-left:4px;
  font-size:0.9em;
}
div.insights table tr.subheader td {
  font-weight:bold;
  border-bottom:1px dashed #ccc;
}
div.map-title {
  color:#666;
  background-color:#eee;
  font-weight:bold;
  font-size:0.7em;
  padding:8px 8px;
  text-align:left;
  border-bottom:0px solid #444;
  width:100%;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
form.layer-select-overlay {
  font-size:0.65em;
  background: rgba(0, 0, 0, 0.5);
  margin:0px;
  z-index:999999999;
}
form.layer-select-overlay label {
  color:#ccc;
}

form.layer-selector-form {
  font-size:0.75em;
  padding:5px 10px;
}
form.layer-selector-form p, form.feedback-form p {
  font-size:15px;
  padding:0px 0px;
  color:#666;
  margin-bottom:7px;

}
a.layer-selector-link {
  border-style:solid;
  border-color:#555;
}
a.layer-selector-link:hover {
  border-color:#555;
  border-style:solid;
  border-width:1px !important;
  background-color:yellow !important;
}
h4 {
  margin:0px;
  padding:8px;
  padding-left:10px;
  font-size:0.9em;
  width:100%;
  color:#444;
}
h5 {
  font-size:0.7em;
  color:#666;
  font-weight:600;
  padding:5px 0px 5px 0px;
  margin:0px;

}
</style>